import { cva, type VariantProps } from "class-variance-authority";
import type { ComponentPropsWithRef, ComponentType } from "react";
import { LuCheck, LuCircleAlert, LuInfo, LuTriangleAlert } from "react-icons/lu";
import type { EventLogStatusEnum } from "@/features/diagnostics/types";
import { cn } from "@/utils/style.ts";

const eventLogVariants = cva("event-log-item", {
    variants: {
        status: {
            success: "event-log-item--success",
            warning: "event-log-item--warning",
            error: "event-log-item--error",
            info: "event-log-item--info",
        },
    },
});

type EventLogVariants = VariantProps<typeof eventLogVariants>;
type EventLogItemRootProps = ComponentPropsWithRef<"li"> & EventLogVariants;
export function EventLogItemRoot({ className, status, ...props }: EventLogItemRootProps) {
    return <li {...props} className={eventLogVariants({ status, className })} />;
}

const STATUS_ICONS: Record<EventLogStatusEnum, ComponentType<ComponentPropsWithRef<"svg">>> = {
    success: LuCheck,
    warning: LuTriangleAlert,
    error: LuCircleAlert,
    info: LuInfo,
};

type EventLogIconProps = ComponentPropsWithRef<"svg"> & { status: EventLogStatusEnum };
export function EventLogIcon({ status, className, ...props }: EventLogIconProps) {
    const Icon = STATUS_ICONS[status];
    return <Icon {...props} className={cn("event-log-item__icon", className)} />;
}

type EventLogTimeProps = ComponentPropsWithRef<"time">;
export function EventLogTime({ className, ...props }: EventLogTimeProps) {
    return <time {...props} className={cn("event-log-item__time", className)} />;
}

type EventLogMessageProps = ComponentPropsWithRef<"span">;
export function EventLogMessage({ className, ...props }: EventLogMessageProps) {
    return <span {...props} className={cn("event-log-item__message", className)} />;
}
